import { Types } from '@store/types';

const initialState = [];

const AccountManagerReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ACCOUNT_MANAGER_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default AccountManagerReducer;
